import { useState } from 'react';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { useNavigate } from 'react-router-dom';
import ReminderLogs from './reminderLogs';
import GlobalSettingsView from './GlobalSettingsView';

// Same hub pattern as Email Templates (src/layouts/emailTemplates/index.jsx): a
// gradient header with view-switcher tabs (default view first), plus a button out to
// the one part of the module that stays its own full page (User Overrides — like
// Email Branding does for Email Templates).
const GlobalReminderSettings = () => {
  const [view, setView] = useState('logs'); // 'logs' | 'global'
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2} mt={-3} py={3} px={2}
            variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info"
            display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}
          >
            <MDBox>
              <MDTypography variant="h6" color="white">Reminder Settings</MDTypography>
              <MDTypography variant="caption" color="white" sx={{ opacity: 0.8 }}>
                Email + SMS reminders for renewals, due dates, overdue payments, and abandoned carts
              </MDTypography>
            </MDBox>
            <MDBox display="flex" gap={1} flexWrap="wrap">
              <MDButton
                variant={view === 'logs' ? 'contained' : 'outlined'}
                color="white"
                onClick={() => setView('logs')}
              >
                Reminder Logs &amp; Status
              </MDButton>
              <MDButton
                variant={view === 'global' ? 'contained' : 'outlined'}
                color="white"
                onClick={() => setView('global')}
              >
                Global Settings
              </MDButton>
              <MDButton
                variant="outlined"
                color="white"
                onClick={() => navigate('/admin/user-reminder-settings')}
              >
                <Icon sx={{ mr: 0.5 }} fontSize="small">person</Icon>
                User Overrides
              </MDButton>
            </MDBox>
          </MDBox>

          <MDBox p={3}>
            {view === 'logs' ? <ReminderLogs /> : <GlobalSettingsView />}
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
};

export default GlobalReminderSettings;
